/**
 * Person search / pagination limits — keep in sync with:
 * `portal/apps/backend/src/person/person-constants.ts`
 */
export const SEARCH_MIN_LENGTH = 3;
export const SEARCH_DEFAULT_PAGE_SIZE = 25;
export const SEARCH_MAX_PAGE_SIZE = 100;
